import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/QAListManagerment';

const QAListReducer = handleActions({
    [Actions.GetListQARequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListQARequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListQARequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),

    // create
    [Actions.createQARequested]: (state) => ({
        ...state,
        isFetching: true,
        createSuccess: false,
    }),
    [Actions.createQARequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        createSuccess: true,
    }),
    [Actions.createQARequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        createSuccess: false,
    }),

    // update
    [Actions.updateQARequested]: (state) => ({
        ...state,
        isFetching: true,
        updateSuccess: false,
    }),
    [Actions.updateQARequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        updateSuccess: true,
    }),
    [Actions.updateQARequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        updateSuccess: false,
    }),

    // delete
    [Actions.deleteQARequested]: (state) => ({
        ...state,
        isFetching: true,
        deleteSuccess: false,
    }),
    [Actions.deleteQARequestedReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        deleteSuccess: true,
    }),
    [Actions.deleteQARequestedReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        deleteSuccess: false,
    }),

    [Actions.clearListQA]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),

}, {
    isFetching: false,
    data: {},
    errors: {},
    createSuccess: false,
    updateSuccess: false,
    deleteSuccess: false,
});

export default combineReducers({
    qAList: QAListReducer,
});
